import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Layers, Loader2 } from 'lucide-react';
import { getPublicCollections } from '../services/cms';
import { useTexts } from '../context/TextsContext';

const Collections = () => {
  const { t } = useTexts();
  const [collections, setCollections] = useState(null);
  useEffect(() => { getPublicCollections().then(setCollections).catch(() => setCollections([])); }, []);

  return (
    <div className="max-w-7xl mx-auto px-4 py-10 min-h-[60vh]" data-testid="collections-page">
      <div className="mb-10">
        <h1 className="font-display font-700 text-4xl text-foreground mb-2 flex items-center gap-3"><Layers className="w-8 h-8 text-primary" /> {t('collections_title', 'Collections')}</h1>
        <p className="text-muted-foreground font-600 max-w-2xl">{t('collections_intro', 'Des séries thématiques pour explorer un territoire, un lieu de mémoire ou une époque, un webtoon à la fois.')}</p>
      </div>

      {collections === null ? (
        <div className="py-20 flex justify-center"><Loader2 className="w-8 h-8 animate-spin text-primary" /></div>
      ) : collections.length === 0 ? (
        <p className="text-muted-foreground font-600">{t('collections_empty', 'Aucune collection publique pour le moment.')}</p>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {collections.map((c, i) => (
            <Link key={c.slug} to={`/collection/${encodeURIComponent(c.slug)}`} data-testid={`collection-card-${c.slug}`}
              className="card-hover group relative rounded-2xl overflow-hidden h-56 animate-float-up border border-border" style={{ animationDelay: `${i * 60}ms` }}>
              {c.cover
                ? <img src={c.cover} alt={c.name} loading="lazy" className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" />
                : <div className="w-full h-full flex items-center justify-center p-4" data-testid={`collection-fallback-${c.slug}`} style={{ background: 'linear-gradient(135deg,#1f2937,#0f172a)' }}><span className="font-display font-700 text-white/90 text-xl text-center leading-tight">{c.name}</span></div>}
              <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/25 to-transparent" />
              <div className="absolute bottom-4 left-4 right-4 text-white">
                <span className="text-xs font-800 uppercase tracking-wide text-secondary">{c.count} webtoon{c.count > 1 ? 's' : ''}</span>
                <h2 className="font-display font-600 text-xl leading-tight mt-1">{c.name}</h2>
                {c.description && <p className="text-xs text-white/80 font-600 mt-1 line-clamp-2">{c.description}</p>}
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
};

export default Collections;
